module.exports = __webpack_public_path__ + "static/Apercu-Medium-fdc5185301065d9784c50a34ca60f616.eot";